// extracted by mini-css-extract-plugin
export default {"tasks":"XN-z","task":"YN-z","svg":"ZN-z","text":"_N-z"};